export default "https://d1e6s5z4lzmgxx.cloudfront.net/e6c6b85e-6085-403a-93bd-a279ec1d3907/images/pianissimo-icon.svg?d137bed9a64f5d016235251e760c9298";